/* ---- build/a.js ---- */
(function(){
'use strict';
/* Designs by Afterglow — Slice A: size-chart modal, accordions, footer year */

/* Size chart modal: open/close via data attributes, Escape, focus return */
(function () {
  var modal = document.querySelector('[data-size-chart-modal]');
  var lastFocus = null;
  function openSizeChart(e) {
    if (e) e.preventDefault();
    if (!modal) return;
    lastFocus = document.activeElement;
    modal.hidden = false;
    document.body.style.overflow = 'hidden';
    var closeBtn = modal.querySelector('[data-close-size-chart]');
    if (closeBtn) closeBtn.focus();
  }
  function closeSizeChart() {
    if (!modal) return;
    modal.hidden = true;
    document.body.style.overflow = '';
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  document.querySelectorAll('[data-open-size-chart]').forEach(function (el) {
    el.addEventListener('click', openSizeChart);
  });
  if (modal) {
    modal.querySelectorAll('[data-close-size-chart]').forEach(function (el) {
      el.addEventListener('click', closeSizeChart);
    });
  }
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && modal && !modal.hidden) closeSizeChart();
  });
})();

/* Accordion groups: opening one closes others in the same group */
(function () {
  document.querySelectorAll('details[data-accordion-group]').forEach(function (d) {
    d.addEventListener('toggle', function () {
      if (!d.open) return;
      var group = d.getAttribute('data-accordion-group');
      document.querySelectorAll('details[data-accordion-group="' + group + '"]').forEach(function (other) {
        if (other !== d && other.open) other.open = false;
      });
    });
  });
})();

/* Footer year */
(function () {
  document.querySelectorAll('[data-year]').forEach(function (el) {
    el.textContent = new Date().getFullYear();
  });
})();
})();

/* ---- build/b.js ---- */
(function(){
'use strict';
/* Slice B — mobile nav drawer + cart bubble (vanilla, null-guarded) */

(function () {
  'use strict';

  /* ---- Mobile nav drawer ---- */
  var toggle = document.querySelector('[data-nav-toggle]');
  var drawer = document.querySelector('[data-mobile-nav]');

  function setNav(open) {
    if (!drawer) return;
    drawer.hidden = !open;
    if (toggle) {
      toggle.setAttribute('aria-expanded', String(open));
      toggle.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
    }
  }

  if (toggle && drawer) {
    toggle.addEventListener('click', function () {
      setNav(drawer.hidden);
    });

    var closeBtn = drawer.querySelector('[data-nav-close]');
    if (closeBtn) closeBtn.addEventListener('click', function () { setNav(false); });

    drawer.querySelectorAll('a').forEach(function (link) {
      link.addEventListener('click', function () { setNav(false); });
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !drawer.hidden) setNav(false);
    });
  }

  /* ---- Cart bubble ---- */
  async function updateCartCount() {
    try {
      var res = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
      if (!res.ok) return;
      var cart = await res.json();
      var count = cart.item_count || 0;
      document.querySelectorAll('[data-cart-count]').forEach(function (el) {
        el.textContent = count;
        el.hidden = count === 0;
      });
    } catch (e) {
      /* cart unreachable — leave the bubble as-is */
    }
  }

  function ready() {
    updateCartCount();
    window.addEventListener('cart:updated', updateCartCount);
    document.querySelectorAll('[data-year]').forEach(function (el) {
      el.textContent = new Date().getFullYear();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', ready);
  } else {
    ready();
  }
})();
})();

/* ---- build/c.js ---- */
(function(){
'use strict';
/* Slice C — product page: gallery, variant picker, AJAX add-to-cart, sticky ATC, carousel */
(function () {
  'use strict';
  var money = function (cents) { return '$' + (cents / 100).toFixed(2); };

  /* ---------- Gallery ---------- */
  var gallery = document.querySelector('[data-gallery]');
  var mainImg = gallery ? gallery.querySelector('[data-gallery-main]') : null;
  var thumbs = gallery ? Array.prototype.slice.call(gallery.querySelectorAll('[data-gallery-thumb]')) : [];
  var galleryIndex = 0;

  var showMedia = function (index) {
    if (!mainImg || !thumbs.length) return;
    galleryIndex = (index + thumbs.length) % thumbs.length;
    var t = thumbs[galleryIndex];
    mainImg.src = t.getAttribute('data-src');
    mainImg.srcset = t.getAttribute('data-srcset');
    mainImg.alt = t.getAttribute('data-alt') || '';
    thumbs.forEach(function (th, i) {
      var on = i === galleryIndex;
      if (on) { th.setAttribute('data-active', ''); } else { th.removeAttribute('data-active'); }
      th.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  };
  thumbs.forEach(function (t, i) { t.addEventListener('click', function () { showMedia(i); }); });
  var gPrev = gallery ? gallery.querySelector('[data-gallery-prev]') : null;
  var gNext = gallery ? gallery.querySelector('[data-gallery-next]') : null;
  if (gPrev) gPrev.addEventListener('click', function () { showMedia(galleryIndex - 1); });
  if (gNext) gNext.addEventListener('click', function () { showMedia(galleryIndex + 1); });

  /* ---------- Product JSON ---------- */
  var pjEl = document.querySelector('[data-product-json]');
  var P = null;
  if (pjEl) { try { P = JSON.parse(pjEl.textContent); } catch (e) { P = null; } }

  /* ---------- Variant picker ---------- */
  var picker = document.querySelector('[data-variant-picker]');
  var idInput = document.querySelector('[data-variant-id]');
  var priceEl = document.querySelector('[data-price]');
  var priceRow = priceEl ? priceEl.parentElement : null;
  var compareEl = document.querySelector('[data-compare-price]');
  var saveBadge = document.querySelector('[data-save-badge]');
  var atcBtn = document.querySelector('[data-atc]');
  var stickyPrice = document.querySelector('[data-sticky-price]');

  var readState = function () {
    var groups = picker ? picker.querySelectorAll('[data-option-index]') : [];
    return Array.prototype.map.call(groups, function (g) {
      var sel = g.querySelector('[data-selected]');
      return sel ? sel.getAttribute('data-option-value') : null;
    });
  };

  /* Disable pills with no available variant under the current other selections */
  var updatePillAvailability = function (state) {
    if (!P || !picker) return;
    picker.querySelectorAll('[data-option-index]').forEach(function (group, gi) {
      group.querySelectorAll('[data-option-value]').forEach(function (pill) {
        var val = pill.getAttribute('data-option-value');
        pill.disabled = !P.variants.some(function (v) {
          return v.available && v.options.every(function (o, i) { return i === gi ? o === val : o === state[i]; });
        });
      });
    });
  };

  /* Creates compare-at / save-badge markup if the first variant had none */
  var ensureSaveEls = function () {
    if (!priceRow) return;
    if (!compareEl) { compareEl = document.createElement('s'); compareEl.className = 'price--compare'; priceRow.appendChild(compareEl); }
    if (!saveBadge) { saveBadge = document.createElement('span'); saveBadge.className = 'badge badge--sale'; priceRow.appendChild(saveBadge); }
  };

  var applyVariant = function () {
    if (!P || !picker) return;
    var state = readState();
    var variant = P.variants.find(function (v) { return v.options.every(function (o, i) { return o === state[i]; }); });
    if (!variant) return;
    if (idInput) idInput.value = variant.id;
    if (priceEl) priceEl.textContent = money(variant.price);
    var hasCompare = variant.compare_at_price && variant.compare_at_price > variant.price;
    if (hasCompare) ensureSaveEls();
    if (compareEl) { compareEl.hidden = !hasCompare; if (hasCompare) compareEl.textContent = money(variant.compare_at_price); }
    if (saveBadge) { saveBadge.hidden = !hasCompare; if (hasCompare) saveBadge.textContent = 'Save ' + Math.round((variant.compare_at_price - variant.price) * 100 / variant.compare_at_price) + '%'; }
    if (atcBtn) { atcBtn.disabled = !variant.available; atcBtn.textContent = variant.available ? 'Add to Cart' : 'Sold Out'; }
    if (stickyPrice) stickyPrice.textContent = money(variant.price);
    if (variant.featured_image && mainImg) {
      var sized = function (w) { return variant.featured_image.replace(/_\d+x/, '_' + w + 'x'); };
      mainImg.src = sized(900);
      mainImg.srcset = sized(600) + ' 600w, ' + sized(900) + ' 900w, ' + sized(1200) + ' 1200w';
    }
    if (window.history && window.history.replaceState) { window.history.replaceState({}, '', '?variant=' + variant.id); }
    updatePillAvailability(state);
    syncSticky();
  };

  if (picker) {
    picker.querySelectorAll('[data-option-value]').forEach(function (pill) {
      pill.addEventListener('click', function () {
        var group = pill.closest('[data-option-index]');
        group.querySelectorAll('[data-option-value]').forEach(function (p) { p.removeAttribute('data-selected'); p.setAttribute('aria-pressed', 'false'); });
        pill.setAttribute('data-selected', ''); pill.setAttribute('aria-pressed', 'true');
        var selSpan = group.querySelector('[data-option-selected]');
        if (selSpan) selSpan.textContent = pill.textContent.trim();
        applyVariant();
      });
    });
    updatePillAvailability(readState());
  }

  /* ---------- AJAX add-to-cart ---------- */
  var productForm = document.querySelector('[data-product-form] form');
  if (productForm && atcBtn) {
    productForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var original = atcBtn.textContent;
      atcBtn.disabled = true;
      atcBtn.textContent = 'Adding…';
      try {
        fetch('/cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(productForm) })
          .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
          .then(function () {
            window.dispatchEvent(new CustomEvent('cart:updated'));
            atcBtn.textContent = 'Added ✓';
            setTimeout(function () { atcBtn.disabled = false; atcBtn.textContent = original; }, 1500);
          })
          .catch(function () { productForm.submit(); });
      } catch (err) { productForm.submit(); }
    });
  }

  /* ---------- Sticky add-to-cart bar ---------- */
  var sticky = document.querySelector('[data-sticky-atc]');
  var buyPanel = document.querySelector('[data-buy-panel]');
  var panelVisible = true;

  var syncSticky = function () {
    if (!sticky) return;
    sticky.hidden = panelVisible || (atcBtn && atcBtn.disabled) || window.scrollY < 400;
  };

  if (sticky && buyPanel && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) { panelVisible = entries[0].isIntersecting; syncSticky(); }).observe(buyPanel);
    window.addEventListener('scroll', syncSticky, { passive: true });
  }

  var stickyAdd = sticky ? sticky.querySelector('[data-sticky-add]') : null;
  if (stickyAdd) stickyAdd.addEventListener('click', function () {
    var form = document.querySelector('[data-product-form] form'); if (form) form.requestSubmit();
  });

  /* ---------- Related products carousel ---------- */
  document.querySelectorAll('[data-carousel]').forEach(function (c) {
    var track = c.querySelector('.carousel__track');
    var prev = c.querySelector('[data-carousel-prev]');
    var next = c.querySelector('[data-carousel-next]');
    if (!track) return;
    var step = function () { return Math.min(640, track.clientWidth); };
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step() }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: step() }); });
  });
})();
})();

/* ---- build/d.js ---- */
(function(){
'use strict';
/* Slice D — sort select + cart qty steppers. Null-guarded; IIFE-wrapped by assembler. */

(function () {
  'use strict';

  // Collection sort select: reload with new sort_by param
  var sortSelect = document.querySelector('[data-sort]');
  if (sortSelect) {
    sortSelect.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sortSelect.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  }

  // Cart qty steppers: adjust input then submit the cart form
  function stepButton(input, delta) {
    var current = parseInt(input.value, 10);
    if (isNaN(current)) current = 0;
    var next = Math.max(0, current + delta);
    input.value = next;
    var form = input.closest('form');
    if (form) {
      if (typeof form.requestSubmit === 'function') {
        form.requestSubmit();
      } else {
        form.submit();
      }
    }
  }

  document.addEventListener('click', function (event) {
    var minus = event.target.closest('[data-qty-minus]');
    var plus = event.target.closest('[data-qty-plus]');
    if (!minus && !plus) return;
    var container = (minus || plus).closest('[data-qty]');
    if (!container) return;
    var input = container.querySelector('input');
    if (!input) return;
    stepButton(input, minus ? -1 : 1);
  });
})();
})();

